import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=a98ca21c&scoped=true&"
import script from "./IndexLayout.vue?vue&type=script&lang=js&"
export * from "./IndexLayout.vue?vue&type=script&lang=js&"
import style0 from "./IndexLayout.vue?vue&type=style&index=0&id=a98ca21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98ca21c",
  null
  
)

export default component.exports